import { CommonService } from '@/service/CommonService';
import { ref } from 'vue';

export const chartOfAccountLevel = 4;

export const partyTypeConstants = {
    customer: 1,
    supplier: 2
};

export const productTypeConstants = {
    raw: 1,
    storeSpare: 2,
    semiFinished: 3,
    finishedGoods: 4,
    fixedAssets: 5,
    rawAndSemiFinished: [1, 3],
    semiAndfinishedGoods: [3, 4]
};

export const stageValueConstants = {
    deleted: '0',
    awaitingApproval: '1',
    managerApproved: '2',
    adminApproved: '3'
};

export const FilterMatchMode = {
    STARTS_WITH: 'startsWith',
    CONTAINS: 'contains',
    NOT_CONTAINS: 'notContains',
    ENDS_WITH: 'endsWith',
    EQUALS: 'equals',
    NOT_EQUALS: 'notEquals',
    IN: 'in',
    LESS_THAN: 'lt',
    LESS_THAN_OR_EQUAL_TO: 'lte',
    GREATER_THAN: 'gt',
    GREATER_THAN_OR_EQUAL_TO: 'gte',
    BETWEEN: 'between',
    DATE_IS: 'dateIs',
    DATE_IS_NOT: 'dateIsNot',
    DATE_BEFORE: 'dateBefore',
    DATE_AFTER: 'dateAfter'
};

export const stageLabelConstants = (stage) => {
    switch (stage) {
        case '0':
            return 'Marked Deleted';
        case '1':
            return 'Awaiting Approval';
        case '2':
            return 'Manager Approved';
        case '3':
            return 'Admin Approved';
        default:
            return 'Ready to Submit';
    }
};
export const revertStageLabelConstants = (stage) => {
    switch (stage) {
        case '1':
            return 'Reverted to Awaiting Approval';
        case '2':
            return 'Reverted to Manager Approval';
        case '3':
            return 'Reverted to Admin Approval';
        default:
            return 'Reverted to Unknown Stage';
    }
};
export const stageIconColorConstants = (stage) => {
    switch (stage) {
        case '0':
            return 'text-red-500';
        case '1':
            return 'text-yellow-500';
        case '2':
            return 'text-blue-500';
        case '3':
            return 'text-green-500';
        default:
            return 'text-cyan-500';
    }
};

export const invoiceStatusColorConstants = (status) => {
    switch (status) {
        case 'Cleared':
            return 'success';
        case 'Partial':
            return 'warn';
        case 'Outstanding':
            return 'danger';
        default:
            return 'secondary';
    }
};

export const VoucherTypeConstants = {
    //opening
    opening_journal: 'OJV',
    //finanical
    cash_receipt: 'CR',
    cash_payment: 'CP',
    cash_voucher: 'CV',
    bank_receipt: 'BR',
    bank_payment: 'BP',
    journal: 'JV',
    //finanical facotry
    cash_receipt_factory: 'CRF',
    cash_payment_factory: 'CPF',
    journal_factory: 'JVF',
    //purchase
    purchase_invoice: 'PI',
    purchase_return_invoice: 'PR',
    //sale
    sales_order: 'SO',
    sales_invoice: 'SI',
    sales_return_invoice: 'SR',
    sales_invoice_factory: 'SIF',
    sales_return_invoice_factory: 'SRF',
    //inventory
    goods_receipt_note: 'GRN',
    goods_receipt_return_note: 'GRRN',
    raw_product_adjustment: 'RPA',
    raw_product_adjustment_value_based: 'RPAVB',
    finished_product_adjustment_value_based: 'FPAVB',
    raw_product_consumption: 'RPC',
    raw_product_consumption_return: 'RPCR',
    raw_product_transfer: 'RPT',
    finished_product_transfer: 'FPT',
    delivery_challan: 'DC',
    delivery_challan_return: 'DCR',
    bill_of_materials: 'BOM',
    production: 'PD',
    finished_product_bill_of_materials: 'FPBOM',
    composition_of_materials: 'COM',
    finished_product_production: 'FPPD'
};

export const statusValueConstants = {
    all: '',
    active: '1',
    inActive: '0'
};

export const buttonSizeConstants = {
    size: 'normal'
};

export const buttonCustomSizeConstants = {
    size: '35px'
};

export const textSizeConstants = {
    size: 'text-base'
};

export const accountTypeIdConstants = {
    cashInHand: 0,
    bank: 1,
    glAccount: 2,
    salesIncome: 3,
    salesDiscount: 4,
    salesReturnIncome: 5,
    inventoryAssets: 6,
    costOfSales: 7,
    wipAccount: 8,
    purchaseAccount: 9,
    purchaseDiscount: 10,
    purchaseReturnAccount: 11,
    purchaseReturnDiscountAccount: 12,
    salesTaxAccount: 13,
    purchaseTaxAccount: 14,
    whtAccount: 15,
    salesReturnDiscount: 16,
    expense: 17,
    longTermAssets: 18,
    advanceDeposits: 19,
    otherCurrentAssets: 20,
    equity: 21,
    longTermLiabilities: 22,
    taxation: 23
};

export const accountIdConstants = {
    accounts: ref(null),
    async load() {
        const response = await CommonService.getGeneralAccountMapping();
        const data = Array.isArray(response) ? response[0] || null : response?.data || response || null;
        this.accounts.value = {
            sales_account_id: data ? (data.sales_account_id ?? null) : null,
            sales_return_account_id: data ? (data.sales_return_account_id ?? null) : null,
            factory_sales_account_id: data ? (data.factory_sales_account_id ?? null) : null,
            factory_sales_return_account_id: data ? (data.factory_sales_return_account_id ?? null) : null,
            sales_discount_account_id: data ? (data.sales_discount_account_id ?? null) : null,
            sales_tax_account_id: data ? (data.sales_tax_account_id ?? null) : null,
            purchase_account_id: data ? (data.purchase_account_id ?? null) : null,
            purchase_return_account_id: data ? (data.purchase_return_account_id ?? null) : null,
            purchase_discount_account_id: data ? (data.purchase_discount_account_id ?? null) : null,
            purchase_tax_account_id: data ? (data.purchase_tax_account_id ?? null) : null,
            cash_in_hand_account_id: data ? (data.cash_in_hand_account_id ?? null) : null,
            factory_cash_in_hand_account_id: data ? (data.factory_cash_in_hand_account_id ?? null) : null,
            petty_cash_in_hand_account_id: data ? (data.petty_cash_in_hand_account_id ?? null) : null,
            inventory_control_account_id: data ? (data.inventory_control_account_id ?? null) : null,
            cost_of_goods_sold_account_id: data ? (data.cost_of_goods_sold_account_id ?? null) : null,
            account_receivable_id: data ? (data.account_receivable_id ?? null) : null,
            account_payable_id: data ? (data.account_payable_id ?? null) : null,
            freight_inward_account_id: data ? (data.freight_inward_account_id ?? null) : null,
            freight_outward_account_id: data ? (data.freight_outward_account_id ?? null) : null,
            wht_payable_account_id: data ? (data.wht_payable_account_id ?? null) : null,
            wht_receivable_account_id: data ? (data.wht_receivable_account_id ?? null) : null
        };
    },

    get(key) {
        return this.accounts.value?.[key] ?? null;
    },

    getAll() {
        return this.accounts.value || {};
    }
};
export const dataTableFontSizeLabel = 'Small';

export const dataTableFontSizeValue = 'small';

export const dataTableFontSizeOptions = ref([
    { label: 'Small', value: 'small' },
    { label: 'Normal', value: 'null' },
    { label: 'Large', value: 'large' }
]);

export const tooltipLookupConstants = {
    balanceSummary: 'View Balance Summary',
    ledger: 'View Ledger',
    voucherSummary: 'View Voucher Summary'
};

export const slabColor = {
    slabColor1: 'rgb(79, 157, 219)',
    slabColor2: 'rgb(72, 181, 163)',
    slabColor3: 'rgb(110, 187, 126)',
    slabColor4: 'rgb(244, 180, 84)',
    slabColor5: 'rgb(240, 143, 74)',
    slabColor6: 'rgb(229, 115, 115)',
    slabColor7: 'rgb(211, 94, 94)',
    slabColor8: 'rgb(186, 74, 74)'
};
